export interface IActionsList {
  currency: string;
  availableActions: EActionTypes[];
}

export enum EActionTypes {
  buy = 'buy',
  sell = 'sell',
  deposit = 'deposit',
  withdraw = 'withdraw',
}

export type TActionItem = {
  type: EActionTypes;
  icon: string;
  label: string;
  description: Function;
  link: Function;
};

export type TActionKeys = EActionTypes.withdraw | EActionTypes.buy | EActionTypes.deposit | EActionTypes.sell;
interface IActionItemDetails { icon: string; type: EActionTypes; label: string; description: Function; link: Function; }
export type TActionsData = {
  [key in TActionKeys]: IActionItemDetails
};
